import React from 'react';
import PropTypes from 'prop-types';

import { formatCurrency } from '../../utils/format';

const OrderItem = ({ label, price, quantity }) => (
  <div className="order-item">
    <div className="order-item-label">{`${quantity == 0 ? "" : quantity + ' x '} ${label}`}</div>
    <div className="order-item-price">{formatCurrency(price)}</div>
  </div>
);
OrderItem.defaultProps = {
  label: null,
  price: 0,
  quantity: 1,
};
OrderItem.propTypes = {
  label: PropTypes.string,
  price: PropTypes.number,
  quantity: PropTypes.number,
};

export default OrderItem;
